import moment from 'moment-timezone';
import { EUROPE_LONDON_TIME_ZONE } from '../constants/dateFormat';

export const CITYSPRINT_QUOTE_BUCKET_ORDER = [
  { key: 'sameDay', id: 'same-day', title: 'Same Day' },
  { key: 'timed', id: 'timed', title: 'Timed' },
  { key: 'dedicated', id: 'dedicated', title: 'Dedicated' },
];

export const CITYSPRINT_QUOTE_BUCKET_INTRO_TEMPLATE = {
  sameDay: [
    {
      type: 'text',
      value: "Our most cost-effective service, we'll collect by ",
    },
    { type: 'time', role: 'collection' },
    { type: 'text', value: ' and deliver by ' },
    { type: 'time', role: 'delivery' },
    { type: 'text', value: '.' },
  ],
  timed: [
    { type: 'text', value: "The most popular option, we'll collect by " },
    { type: 'time', role: 'collection' },
    { type: 'text', value: ' and deliver by ' },
    { type: 'time', role: 'delivery' },
    {
      type: 'text',
      value: ' or another time after that suits you.',
    },
  ],
  dedicated: [
    { type: 'text', value: "Our most secure service, we'll collect by " },
    { type: 'time', role: 'collection' },
    { type: 'text', value: ' and deliver by ' },
    { type: 'time', role: 'delivery' },
    { type: 'text', value: ', with no other items on board.' },
  ],
};

// eslint-disable-next-line complexity -- mirrors API classifySamedayQuoteService
export function classifyCitysprintQuoteBucket(row) {
  const code = String(row?.networkCode ?? '').trim();
  if (/^8[A-Z0-9]*$/i.test(code)) {
    return 'sameDay';
  }
  if (/^T[A-Z0-9]*$/i.test(code)) {
    return 'timed';
  }
  if (/^[46][A-Z0-9]*$/i.test(code)) {
    return 'dedicated';
  }

  const t0 = Date.parse(row?.latestCollectionTime ?? '');
  const t1 = Date.parse(row?.latestDeliveryTime ?? '');
  if (Number.isNaN(t0) || Number.isNaN(t1)) {
    return 'sameDay';
  }
  if (t0 === t1) {
    return 'sameDay';
  }
  if (t0 < t1) {
    return 'timed';
  }
  return 'dedicated';
}

export function formatCitysprintQuoteTimeLabel(iso) {
  if (iso == null || typeof iso !== 'string' || !iso.trim()) {
    return '—';
  }
  const m = moment.tz(iso, EUROPE_LONDON_TIME_ZONE);
  return m.isValid() ? m.format('HH:mm') : '—';
}
